import { DeadLetterMessage as Message } from '../../../../../services/eventingApi';
import { formatDateTime } from '../shared/format';

const DeadLetterMessage = ({ message }: { message: Message }) => (
  <li className="rounded-md border border-gray-200 p-3 text-xs dark:border-gray-700 dark:text-gray-100">
    <div className="mb-2 flex flex-wrap gap-4 text-gray-500 dark:text-gray-400">
      <span>enviada {formatDateTime(message.sentAt)}</span>
      <span>{message.receiveCount} recebimento(s)</span>
      <span className="font-mono">{message.attributes.eventType ?? ''}</span>
      <span className="font-mono">{message.attributes.eventId ?? message.messageId}</span>
    </div>
    <pre className="max-h-40 overflow-auto rounded bg-gray-900 p-2 text-green-200">{JSON.stringify(message.body, null, 2)}</pre>
  </li>
);

export default DeadLetterMessage;
